"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isFullyAlive = exports.isDeadish = exports.removeDead = exports.findByPlayerNumber = exports.findByIdSafe = exports.findById = exports.genericRegisterDataNum = exports.genericGetDataNum = exports.genericRegisterData = exports.genericFindData = exports.genericGetData = void 0;
var arrayUtils_sidecar_1 = require("@engine/arrayUtils-sidecar");
var assert_sidecar_1 = require("../lib/assert-sidecar");
// export interface ICollidableWithBody extends ICollidable {
//   body: planck.Body
// }
// export interface IEntityWithBody extends IEntity, ICollidableWithBody {}
// export function findByBody<T extends ICollidableWithBody>(
//   body: planck.Body,
//   objs: T[],
// ): T {
//   for (let i = 0; i < objs.length; i++) {
//     if (objs[i].body === body) {
//       return objs[i]
//     }
//   }
//   assert.shouldNotExecute('could not find body')
//   // return null
// }
// export function findByBodySafe<T extends ICollidableWithBody>(
//   body: planck.Body,
//   objs: T[],
// ): T | null {
//   for (let i = 0; i < objs.length; i++) {
//     if (objs[i].body === body) {
//       return objs[i]
//     }
//   }
//   return null
// }
function genericGetData(label, dataMapType, type) {
    if (dataMapType === void 0) { dataMapType = {}; }
    var d = dataMapType['' + type];
    assert_sidecar_1.assert.notNil(d, 'data does not exist', label, type);
    return d;
}
exports.genericGetData = genericGetData;
function genericFindData(label, dataList, key) {
    var d = dataList.find(function (d) { return d.key === key; });
    assert_sidecar_1.assert.notNil(d, 'data does not exist', label, '' + key);
    return d;
}
exports.genericFindData = genericFindData;
function genericRegisterData(label, data, _default, dataList, dataMapType, preFreeze) {
    if (dataMapType === void 0) { dataMapType = {}; }
    assert_sidecar_1.assert.notEmptyString(data.type, 'data requires a type', label);
    if (dataMapType[data.type]) {
        assert_sidecar_1.assert.failed('data type already exists', data.type, label);
    }
    var d = Object.assign({}, _default, data);
    if (preFreeze) {
        preFreeze(d);
    }
    dataMapType[d.type] = d;
    dataList.push(d);
    Object.freeze(d);
}
exports.genericRegisterData = genericRegisterData;
function genericGetDataNum(label, dataMap, type) {
    var d = dataMap[type];
    assert_sidecar_1.assert.notNil(d, 'data does not exist', label, type);
    return d;
}
exports.genericGetDataNum = genericGetDataNum;
function genericRegisterDataNum(label, data, _default, dataList, dataMap, preFreeze) {
    assert_sidecar_1.assert.notNil(data.type, 'data requires a type', label);
    if (dataMap[data.type]) {
        assert_sidecar_1.assert.failed('data type already exists', data.type, label);
    }
    var d = Object.assign({}, _default, data);
    if (preFreeze) {
        preFreeze(d);
    }
    dataMap[d.type] = d; // .push(d)
    dataList.push(d);
    Object.freeze(d);
}
exports.genericRegisterDataNum = genericRegisterDataNum;
function findById(id, objs) {
    for (var i = 0; i < objs.length; i++) {
        if (objs[i].id === id) {
            return objs[i];
        }
    }
    console.log('WARN', 'findById', 'entity not found', id);
    // debugger
    return null;
}
exports.findById = findById;
function findByIdSafe(id, objs) {
    for (var i = 0; i < objs.length; i++) {
        if (objs[i].id === id) {
            return objs[i];
        }
    }
    return null;
}
exports.findByIdSafe = findByIdSafe;
function findByPlayerNumber(playerNumber, objs) {
    for (var i = 0; i < objs.length; i++) {
        if (objs[i].playerNumber === playerNumber) {
            return objs[i];
        }
    }
    // debugger
    return null;
}
exports.findByPlayerNumber = findByPlayerNumber;
function removeDead(objs, onRemove) {
    for (var i = 0; i < objs.length; i++) {
        if (objs[i].isDead) {
            onRemove(objs[i]);
            // objs.splice(i, 1)
            arrayUtils_sidecar_1.arrayUtils.fastSplice(objs, i, 1);
            i--;
        }
    }
}
exports.removeDead = removeDead;
function isDeadish(obj) {
    return !!(!obj || obj.isDead || obj.isDying);
}
exports.isDeadish = isDeadish;
function isFullyAlive(obj) {
    return !!(obj && !obj.isDead && obj.isDying !== true);
}
exports.isFullyAlive = isFullyAlive;
// export function removeBy(
//   objs: IEntity[],
//   filter: (obj: IEntity) => boolean,
//   onRemove: (obj: IEntity) => any,
// ) {
//   for (let i = 0; i < objs.length; i++) {
//     if (filter(objs[i])) {
//       onRemove(objs[i])
//       objs.splice(i, 1)
//       i--
//     }
//   }
// }
